import {
  MenuItem,
  Select,
  FormControl,
  Typography,
  FormHelperText,
} from '@mui/material'
import { Handyman } from '@mui/icons-material'

import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'

import { RemoveScrewModalProps } from '../../TrayVisualization.types'
import './RemoveScrewModal.scss'

const RemoveScrewModal = ({
  open,
  onClose,
  selectedStatus,
  setSelectedStatus,
  handleStatusChange,
  selectedPlate,
  trayType,
  selectedScrews,
}: RemoveScrewModalProps) => {
  const handleStatusSelect = (e: any) => {
    setSelectedStatus(e.target.value)
  }

  const onConfirmClick = () => {
    if (selectedScrews.length === 0 && !selectedPlate) {
      console.error('No screw or plate selected!')
      return
    }
    handleStatusChange()
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className="tray-visualization-remove-screw_modal">
        <div className="header-box">
          <Handyman />

          <Typography variant="h3">
            Confirm {selectedPlate ? 'plate' : 'screw'} status
          </Typography>
        </div>

        <div className="screw-data-container">
          {selectedPlate ? (
            <Typography variant="body2">
              {selectedPlate.deviceDescription || selectedPlate.plateName}
            </Typography>
          ) : (
            selectedScrews.map((screw) => (
              <Typography variant="body2">
                - {screw.label}, (Row {screw.row}, Size {screw.column})
              </Typography>
            ))
          )}
        </div>

        <FormControl fullWidth>
          <Select
            data-testid="add-tray-location-storage_input"
            fullWidth
            variant="outlined"
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Typography variant="body1" color="gray">
                    Select {selectedPlate ? 'plate' : 'screw'} disposition
                  </Typography>
                )
              }

              return `${selectedStatus
                .charAt(0)
                .toUpperCase()}${selectedStatus.slice(1)}`
            }}
            value={selectedStatus}
            onChange={handleStatusSelect}
          >
            <MenuItem disabled value="">
              Select {selectedPlate ? 'plate' : 'screw'} disposition
            </MenuItem>

            <MenuItem value="implanted">Implanted</MenuItem>
            <MenuItem value="wasted">Wasted</MenuItem>
            <MenuItem value="not present">Not Present</MenuItem>
          </Select>

          <FormHelperText>
            Select {selectedPlate ? 'plate' : 'screw'} disposition
          </FormHelperText>
        </FormControl>

        <div className="buttons-container">
          <LoadingButton
            disabled={false}
            loading={false}
            variant="outlined"
            mode="cancel"
            onClick={onClose}
          >
            Cancel
          </LoadingButton>

          <LoadingButton
            disabled={false}
            loading={false}
            onClick={onConfirmClick}
          >
            Confirm
          </LoadingButton>
        </div>
      </div>
    </Modal>
  )
}

export default RemoveScrewModal
